import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a784d37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "title-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "origin",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonShare = _resolveComponent("ButtonShare")!
  const _component_TagContainer = _resolveComponent("TagContainer")!
  const _component_SharePopup = _resolveComponent("SharePopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.eventTitle), 1),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_ButtonShare, {
            text: this.$store.state.language === 'fr' ? 'partager' : 'share',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePopup()))
          }, null, 8, ["text"]),
          _createVNode(_component_TagContainer, { text: _ctx.tagText }, null, 8, ["text"])
        ]),
        _createElementVNode("div", {
          class: "country",
          style: _normalizeStyle([_ctx.country ? { display: 'flex' } : { display: 'none' }])
        }, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.country), 1)
        ], 4)
      ]),
      _createElementVNode("div", {
        ref: "sharepopup",
        onFocusout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closePopup())),
        tabindex: "0"
      }, [
        _withDirectives(_createVNode(_component_SharePopup, {
          class: "popup",
          style: _normalizeStyle(this.origin === 'anEvent' ? { top: '100px' } : { top: '40px' })
        }, null, 8, ["style"]), [
          [_vShow, this.popup]
        ])
      ], 544)
    ]),
    _hoisted_5
  ], 64))
}